const kitToken = process.env.FONTAWESOME_KIT_TOKEN;
const version = process.env.FONTAWESOME_VERSION;

export default function initFontawesome() {
  if (typeof document === 'undefined') return;

  if (document.getElementById('font-awesome-link')) return;

  let src = undefined;
  let preconnectUrl = undefined;

  if (kitToken) {
    src = `https://kit.fontawesome.com/${kitToken}.css`;
    preconnectUrl = 'https://kit.fontawesome.com';
  } else if (version) {
    src = `https://cdnjs.cloudflare.com/ajax/libs/font-awesome/${version}/css/font-awesome.min.css`;
    preconnectUrl = 'https://cdnjs.cloudflare.com';
  }

  if (!src) return;

  // Add preconnect for faster DNS resolution
  if (preconnectUrl && !document.querySelector(`link[href="${preconnectUrl}"]`)) {
    const preconnect = document.createElement('link');
    preconnect.href = preconnectUrl;
    preconnect.rel = 'preconnect';
    preconnect.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect);
  }

  // Load stylesheet with media query trick for async loading
  const link = document.createElement('link');
  link.href = src;
  link.crossOrigin = 'anonymous';
  link.rel = 'stylesheet';
  link.id = 'font-awesome-link';
  link.media = 'print';
  link.onload = function () {
    // @ts-ignore
    this.media = 'all';
  };

  document.head.appendChild(link);
}
